import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BallotModule } from './ballot/ballot.module';
import { VotingSuccessComponent } from './success-page/voting-success.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { AboutVoatzApi, ApiAboutService } from './Services/api-about.service';

import { IdUploadModule } from './id-upload/id-upload.module';
import { FooterComponent } from './footer/footer.component';
import { WelcomeModule } from './welcome/welcome.module';
import { MteService } from './Services/mte.service';
import { SessionEndedComponent } from './session-ended/session-ended.component';
import { BackButtonConfirmationModalModule } from './back-button-confirmation-modal/back-button-confirmation-modal.module';
import { ReviewModule } from './review/review.module';
import { DeclarationComponent } from './declaration/declaration.component';
import { SignatureModule } from './signature/signature.module';
import { BallotErrorModalModule } from './ballot/ballot-error-modal.module';
import { HeadshotUploadModule } from './headshot-upload/headshot-upload.module';
import { IdUploadModalModule } from './id-upload/id-upload-modal.module';
import { WebcamModule } from 'ngx-webcam';
import { HeaderModule } from './header/header.module';
import { CookieModule } from 'ngx-cookie';
import { SessionTimeoutModalModule } from './session-timeout-modal/session-timeout-modal.module';
import { BrowserSupportModule } from './browser-support/browser-support.module';
import { RegistrationComponent } from './registration/registration.component';

import { RegistrationSuccessComponent } from './registration-success/registration-success.component';
import { DeclarationModule } from './declaration/declaration.module';
import { VerifyMfaComponent } from './verify-voter/verify-mfa.component';
import { VerifyVoterComponent } from './verify-voter/verify-voter.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DeclinedComponent } from './declined/declined.component';
import { ProgressBarModule } from './progress-bar/progress-bar.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SessionStorageService } from './Services/session-storage.service';
import { LanguageDropDownModule } from './language-drop-down/language-drop-down.module';
import { MatIconModule } from '@angular/material/icon';
import { SurveyComponent } from './survey/survey.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PetitionComponent } from './petition/petition.component';
import { SignatureComponent } from './signature/signature.component';
import { PrintPageComponent } from './print-page/print-page.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ReturnOptionsModule } from './return-options/return-options.module';
import { NgxCaptchaModule } from "ngx-captcha";
import { PasswordComponent } from './verify-voter/password.component';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { ResetPasswordComponent } from './verify-voter/reset-password/reset-password.component';
import { MatStepperModule } from '@angular/material/stepper';
import { UserMenuModule } from './user-menu/user-menu.module';
import { SharedModule } from "./shared/shared.module";
export const isMock = environment.mock;
export function startupServiceFactory(apiAboutService: ApiAboutService):
  () => Promise<AboutVoatzApi> {
  return () => apiAboutService.about();
}

@NgModule({ declarations: [
        AppComponent,
        VotingSuccessComponent,
        FooterComponent,
        SessionEndedComponent,
        DeclarationComponent,
        RegistrationComponent,
        RegistrationSuccessComponent,
        VerifyMfaComponent,
        VerifyVoterComponent,
        PasswordComponent,
        DeclinedComponent,
        SurveyComponent,
        PetitionComponent,
        SignatureComponent,
        PrintPageComponent,
        ResetPasswordComponent
    ],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        BallotErrorModalModule,
        BallotModule,
        BackButtonConfirmationModalModule,
        BrowserAnimationsModule,
        BrowserModule,
        BrowserSupportModule,
        CommonModule,
        CookieModule.forRoot(),
        DeclarationModule,
        FormsModule,
        HeaderModule,
        HeadshotUploadModule,
        IdUploadModalModule,
        IdUploadModule,
        NgIdleKeepaliveModule.forRoot(),
        NgxIntlTelInputModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatStepperModule,
        ProgressBarModule,
        ReactiveFormsModule,
        ReviewModule,
        SessionTimeoutModalModule,
        SignatureModule,
        UserMenuModule,
        WebcamModule,
        WelcomeModule,
        LanguageDropDownModule,
        MatIconModule,
        MatDialogModule,
        NgxExtendedPdfViewerModule,
        ReturnOptionsModule,
        NgxCaptchaModule,
        MatMenuModule,
        MatButtonModule,
        SharedModule], providers: [
        ApiAboutService,
        MteService,
        SessionStorageService,
        {
            provide: APP_INITIALIZER,
            useFactory: startupServiceFactory,
            deps: [ApiAboutService],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
